export { clickOutMixin } from '../mixins/clickOut';
export { faqMixin } from '../mixins/faq';
export { helper } from '../mixins/helper';
export { routeMixin } from '../mixins/route';
export { mediaQueriesMixin } from '../mixins/mediaQueries';
export { ghostWriterRankingMixin } from '../mixins/ghostWriterRanking';
export { ghostWriterArticleMixin } from '../mixins/ghostWriterArticle';
export { scoreMixin } from '../mixins/partnerScore';
export { colorMixin } from '../mixins/color';
export { countdownTimerMixin } from '../mixins/countdownTimer';
export { contentDirectionMixin } from '../mixins/contentDirection';

export const navigationItemsMixin = {
    data() {
        return {
            parentItems: [],
            mobileMenuOpen: false,
            hideMenuItems: false,
        };
    },
    computed: {
        navItems() {
            this.parentItems = this.$globalConstants.host.menu_items || [];
            return this.parentItems;
        },
    },
    methods: {
        toggleNavMenu() {
            this.mobileMenuOpen = !this.mobileMenuOpen;
        },
        toggleMobileDropdown() {
            this.mobileDropdownOpen = !this.mobileDropdownOpen;
        },
        toggleMenuItems() {
            this.hideMenuItems = !this.hideMenuItems;
        },
    },
};

export function slugify(text) {
    return text
        .toString()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .toLowerCase()
        .trim()
        .replace(/[^a-z0-9 ]/g, '')
        .replace(/\s+/g, '-');
}

export const DateMixin = {
    methods: {
        fallbackDate() {
            const monthNames = [
                'January',
                'February',
                'March',
                'April',
                'May',
                'June',
                'July',
                'August',
                'September',
                'October',
                'November',
                'December',
            ];

            const date = new Date();
            date.setDate(date.getDate() - 3);
            const month = date.getMonth();

            return `${this.$t(
                monthNames[month]
            )} ${date.getDate()}, ${date.getFullYear()}`;
        },
        getBrowserData() {
            const lang = window.__host__
                ? window['__host__']['language_code']
                : 'en';

            try {
                if (Intl.Collator.supportedLocalesOf(lang).length === 0) {
                    return null;
                }
            } catch (e) {
                return null;
            }

            const date = new Date();
            date.setDate(date.getDate() - 3);

            return date.toLocaleDateString(lang, {
                year: 'numeric',
                month: 'long',
                day: 'numeric',
            });
        },
    },
};
